import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import type { ErrorResponse } from '@app/domain/interfaces/response/error-response.interface';
import { UserService } from '@app/services/user/user';
import { userActions } from '@app/store/user/user.actions';

const loadUserDetails = createEffect(
  () => {
    const actions$ = inject(Actions);
    const service = inject(UserService);

    return actions$.pipe(
      ofType(userActions.userDetailsGroup.loadUserDetails),
      switchMap(() => service.userDetails$().pipe(
        map(response => userActions.userDetailsGroup.loadUserDetailsSuccess({ response })),
        catchError((error: ErrorResponse) => of(
          userActions.userDetailsGroup.loadUserDetailsFailure({ error }),
        )),
      )),
    );
  },
  { functional: true },
);

export const userEffects = {
  loadUserDetails,
};
